import { updateCopyrightConfirmation } from '~/api';
import { useForm } from '~/features/form';
import { useDefaultModal } from './defaultModal';

export const useUploadTip = (okCallback: () => void, params?: any) => {
  const { $t } = useNuxtApp();
  const { View, validate, modelRef } = useForm(
    [
      {
        key: 'check',
        inputAttrs: {
          type: 'checkbox',
          options: [
            {
              label: $t(
                'wo-yi-he-shi-bing-que-ren-ji-jiang-shang-chuan-de-su-cai-yi-huo-de-quan-li-ren-de-shang-ye-shi-yong-shou-quan-fou-ze-you-ci-chan-sheng-de-fa-lv-ze-ren-you-wo-zi-hang-cheng-dan',
              ),
              value: 1,
            },
          ],
        },
        formItem: {
          name: 'check',
          rules: [{ required: true, message: $t('qing-gou-xuan-shang-chuan-xu-zhi') }],
        },
      },
    ],
    {
      labelCol: { span: 0 },
      wrapperCol: { span: 24 },
    },
  );
  useDefaultModal({
    title: $t('su-cai-ban-quan-que-ren'),
    center: true,
    content: (
      <div class="p-[20px_20px_0]">
        <View />
      </div>
    ),
    onOk: async () => {
      await validate();
      if (params) {
        await updateCopyrightConfirmation({
          upload_type: params?.upload_type,
          resource_type: params?.resource_type,
        });
      }
      okCallback();
    },
  });
};
